import { ChatWindow } from '@/components/ChatWindow';
import { EddyAvatar } from '@/components/EddyAvatar';

// The dedicated /eddy page — roomy chat for real support back-and-forth.
// Clean by design: a branded header bar + the conversation. Nothing that
// doesn't earn its place.
export function EddyPage() {
  return (
    <div className="flex h-full flex-col bg-surface">
      <header className="flex items-center gap-3 border-b border-brand-100 bg-brand-900 px-4 py-3 sm:px-6">
        <EddyAvatar size={36} />
        <div className="leading-tight">
          <p className="text-sm font-semibold text-white">Eddy</p>
          <p className="text-xs text-brand-200">EDIBridge Support</p>
        </div>
        <span className="ml-auto inline-flex items-center gap-1.5 text-xs text-brand-200">
          <span className="h-2 w-2 rounded-full bg-emerald-400" />
          Online
        </span>
      </header>

      <main className="min-h-0 flex-1">
        <ChatWindow variant="page" />
      </main>
    </div>
  );
}
